import type {LineDashType} from '@PosterWhiteboard/items/line-item/line-item.types';

export interface LineDashOptions {
  id: LineDashType;
}

export const DEFAULT_CUSTOM_DASH_SIZE = 30;
export const DEFAULT_CUSTOM_GAP_SIZE = 10;